import { render } from "./loginInfo.vue?vue&type=template&id=18979a2b&scoped=true"
import script from "./loginInfo.vue?vue&type=script&lang=js"
export * from "./loginInfo.vue?vue&type=script&lang=js"

import "./loginInfo.vue?vue&type=style&index=0&id=18979a2b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18979a2b"]])

export default __exports__